import { jsx as n } from "react/jsx-runtime";
import { R as p } from "../../../../main-CrXd0pgv.js";
const R = ({ imageSrc: r, imageSrcMobile: s, imageSrcTablet: i, alt: t, className: e }) => {
  const { isMobile: m, isTablet: f } = p();
  let o = r;
  return m && s && (o = s), f && i && (o = i), /* @__PURE__ */ n("img", { className: e, src: o, alt: t });
};
export {
  R as ImageResponsive
};
